import { action } from 'satcheljs';

/**
 * Called when we select discard, resets the event options in store
 */

let discardEventOption = action('discardEventOption', () => ({}));

export default discardEventOption;
